import React, { useState, useEffect } from "react"
import { useNavigate, useParams } from "react-router-dom"
import TMHBanner from "../../components/TMHBanner/TMHBanner"
import TMHLoader from "../../components/TMHLoader/TMHLoader"
import "./RequestCouponPage.scss"
import useAuth from "../../core/Authentication/useAuth"
import { ReactComponent as ArrowRight } from "./img/feather-arrow-right-icon.svg"
import TickImg from "./img/tick.png"
import ExtImg from "./img/extension-laptop.png"
import MobileAppImg from "./img/mobile-app-ss.png"
import NotesImg from "./img/tick-notes.png"
import config from "../../config.json"
import { useTitle } from "react-use"
import ReactGA from "react-ga4"
import {
  getUserInfo,
  getAvailableCodes,
  verifyPin,
  registerByPinAPI,
  checkSupportAndroidVersion,
} from "../../core/APIService/apiService"
import Popup from "reactjs-popup"

function isGGChrome() {
  var isChromium = window.chrome
  var winNav = window.navigator
  var vendorName = winNav.vendor
  var isOpera = typeof window.opr !== "undefined"
  var isIEedge = winNav.userAgent.indexOf("Edg") > -1
  var isIOSChrome = winNav.userAgent.match("CriOS")

  if (isIOSChrome) {
    // is Google Chrome on IOS
    return false
  } else if (
    isChromium !== null &&
    typeof isChromium !== "undefined" &&
    vendorName === "Google Inc." &&
    isOpera === false &&
    isIEedge === false
  ) {
    // is Google Chrome
    return true
  } else {
    // not Google Chrome
    return false
  }
}

export default function RequestCouponPage() {
  useTitle("Request Coupon - The Movie House TV")
  const auth = useAuth()
  const navigate = useNavigate()
  const rokuRemoteExtUrl =
    "https://chrome.google.com/webstore/detail/roku-remote/jngdnnffdlbidhgfhplljlcpnocckcpc"

  const { pin, email_hash } = useParams()
  const registerMode =
    pin !== undefined && email_hash !== undefined && pin.length === 8
  const [openRegisterPopup, setOpenRegisterPopup] = useState(false)
  const [openRegisterChromePopup, setOpenRegisterChromePopup] = useState(false)
  const [openVuduCodeWarningPopup, setOpenVuduCodeWarningPopup] =
    useState(false)
  const [isTermCheckboxChecked, setIsTermCheckboxChecked] = useState(false)
  const [password, setPassword] = useState("")
  const [confirmPassword, setConfirmPassword] = useState("")
  const [registerErr, setRegisterErr] = useState("")
  const [registerPartnerId, setRegisterPartnerId] = useState(2)
  const isRegisterButtonDisabled =
    password !== confirmPassword ||
    password.length < 6 ||
    !isTermCheckboxChecked

  const [isSuccess, setIsSuccess] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [isFirstLoad, setIsFirstLoad] = useState(registerMode)
  const [progressLocked, setProgressLocked] = useState(false)
  const [useSpinner, setUseSpinner] = useState(true)
  const [requiredApp, setRequiredApp] = useState("")
  const [isSpin2, setIsSpin2] = useState(false)
  const [error, setError] = useState("")
  const [vuduAvailable, setVuduAvailable] = useState(true)
  const [isVuduCodeLimitedWarning, setIsVuduCodeLimitedWarning] =
    useState(false)
  const [amzAvailable, setAmzAvailable] = useState(true)
  const [openPopup, setOpenPopup] = useState(false)

  const vuduLogo = require("./img/vudu-logo.png")
  const primeLogo = require("./img/prime-video.png")

  const unavailableLogo = require("./img/logo-unavailable.png")
  const movie1 = require("./img/movie-1.png")
  const movie2 = require("./img/movie-2.png")
  const movie3 = require("./img/movie-3.png")
  const movie4 = require("./img/movie-4.png")
  const movie5 = require("./img/movie-5.png")
  const movie6 = require("./img/movie-6.png")
  const movie7 = require("./img/movie-7.png")
  const movie8 = require("./img/movie-8.png")

  function handleRequestButton(partnerId = 4) {
    var myHeaders = new Headers()
    myHeaders.append("Content-Type", "application/json")
    myHeaders.append("Access-Token", auth.user?.token)
    myHeaders.append("Cache-Control", "no-cache")

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: JSON.stringify({
        partner_id: partnerId,
      }),
    }

    setIsLoading(true)
    setError("")
    fetch(config.baseUrl + "confirm_reward", requestOptions)
      .then(response => {
        return new Promise(resolve =>
          response.json().then(json =>
            resolve({
              status: response.status,
              ok: response.ok,
              json,
            })
          )
        )
      })
      .then(
        result => {
          setIsSuccess(result.ok)
          if (result.ok) {
            setUseSpinner(result.use_spinner)
            setProgressLocked(result.progress_locked ?? false)
          } else {
            setError(result.json.message)
          }
          setIsLoading(false)
          setOpenPopup(false)
          setOpenRegisterPopup(false)
          setOpenRegisterChromePopup(false)
          setOpenVuduCodeWarningPopup(false)
        },
        error => {
          console.log(error)
          setError(error.toString())
          setIsLoading(false)
          setOpenPopup(false)
          setOpenRegisterPopup(false)
          setOpenRegisterChromePopup(false)
          setOpenVuduCodeWarningPopup(false)
        }
      )
  }

  useEffect(() => {
    async function fetchData() {
      if (!auth.isLogged() && (pin === undefined || pin.length < 8)) {
        navigate("/login")
        return
      } else {
        if (registerMode && checkSupportAndroidVersion()) {
          window.location.href = "https://freemoviespin.com/"
          return
        }
        setIsLoading(true)
        if (registerMode && auth.isLogged()) {
          auth.logout()
          return
        }
        var user_id = auth.user?.user_id
        var availableCodes = await getAvailableCodes(user_id)
        if (availableCodes.status === 200) {
          if (availableCodes.data) {
            for (const codeIndex in availableCodes.data) {
              if (availableCodes.data[codeIndex].id === 2) {
                setAmzAvailable(availableCodes.data[codeIndex].is_available)
              } else if (availableCodes.data[codeIndex].id === 4) {
                setVuduAvailable(availableCodes.data[codeIndex].is_available)
                setIsVuduCodeLimitedWarning(
                  Boolean(availableCodes.data[codeIndex].is_warning)
                )
              }
            }
          }
        }

        var pinInfo = {
          pin_status: 0,
        }

        if (registerMode) {
          pinInfo = await verifyPin(pin, email_hash)

          if (pinInfo.pin_status !== 1) {
            navigate("/request-coupon")
            return
          }
          setIsSpin2(true)
          setProgressLocked(pinInfo.progress_locked ?? false)

          if (isGGChrome()) {
            setOpenRegisterChromePopup(true)
          }
        } else {
          const data = await getUserInfo(auth.user?.token)

          if (!data || data.status !== 200) {
            auth.logout()
            navigate("/login")
            return
          }

          setRequiredApp(data.required_app ?? "")
          setUseSpinner(data.use_spinner)
          setIsSpin2(data.is_spin2)
        }

        ReactGA.send("pageview")
        setIsFirstLoad(false)
        setIsLoading(false)
      }
    }
    fetchData()
  }, [auth, navigate, pin, email_hash, registerMode])

  async function registerByPin(pw, extension = false) {
    setIsLoading(true)
    const data = await registerByPinAPI(
      pin,
      email_hash,
      pw,
      registerPartnerId,
      extension
    )
    setIsLoading(false)

    if (data.message === "PIN_NOT_FOUND") {
      setRegisterErr("Pin not found, please try again!")
    } else {
      if (data.token !== null) {
        let user = {}
        user.token = data.token
        user.username = data.username
        user.user_id = data.user_id
        user.pin = data.pin

        auth.login(user)

        if (data.message === "EXTENSION") {
          window.open(rokuRemoteExtUrl, "_blank")
          setOpenRegisterChromePopup(false)
          navigate("/request-coupon")
        } else {
          navigate("/profile/congratulation-next-spinner")
        }
      } else {
        setRegisterErr("Something went wrong, please try again!")
      }
    }
  }

  return (
    <>
      {!isFirstLoad && (
        <TMHBanner
          styleId={2}
          classOption="only-gradient"
          useSpinner={useSpinner}
          showLoginInfo={!isSpin2}
        >
          <div className="request-coupon-wrapper">
            {isSuccess ? (
              <div className="box-success">
                <div className="box-wraper">
                  <div className="box-title">
                    Your request has been received
                  </div>
                  <div className="box-content">
                    <p>
                      You will receive an email to {auth.user?.username} within
                      24 hours with your gift card and instructions on how to
                      use it to watch your movie!
                    </p>
                    {!isSpin2 ? (
                      <p>
                        {/* Your progress bar has been reset back to 0%. While you wait for your gift card to arrive keep watching to your way to another free movie! */}
                        <b>
                          Keep your up with your daily spinning for more great
                          movie prizes!
                        </b>
                      </p>
                    ) : (
                      <p>
                        <b>
                          Now you can spin again! go back to your Roku device
                          and your second spin will now be available!
                        </b>
                      </p>
                    )}
                    <button
                      onClick={() => {
                        window.open("about:blank", "_self")
                        window.close()
                      }}
                    >
                      CLOSE WINDOW
                    </button>
                  </div>
                </div>
              </div>
            ) : (
              <div className="box">
                <div className="box1">
                  <div className="box-wraper">
                    <div className="box-title">
                      Request your gift card for a free movie!
                    </div>
                    <div className="box-content">
                      You're almost there!
                      <div className="box-list-item">
                        <div>
                          <ArrowRight />
                          <p>
                            Please select how you want to watch your free movie
                            from the options shown.
                          </p>
                        </div>
                        <div>
                          <ArrowRight />
                          <p>
                            Once you have selected an option, you will receive a
                            gift card and instructions on how to use it via
                            email.
                          </p>
                        </div>
                        <div>
                          <ArrowRight />
                          <p>Your email address is {auth.user?.username}.</p>
                        </div>
                        <div>
                          <ArrowRight />
                          <p>
                            If this is not correct, please correct it on your
                            profile page prior to selecting your gift card
                            option.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="box2">
                  <div className="box-wraper">
                    <div className="box-title">
                      Where do you want to <span>watch your free movie?</span>
                    </div>

                    <div className="box-content">
                      <div className="box-list-item">
                        <div className="item">
                          <div className="logo-item">
                            {!amzAvailable && (
                              <img
                                className="logo-prime"
                                style={{ position: "absolute" }}
                                src={unavailableLogo}
                                alt="unavailable-logo"
                              ></img>
                            )}
                            <img
                              className="logo-prime"
                              src={primeLogo}
                              alt="prime-video"
                            ></img>
                            <a
                              className="logo-link"
                              href="/tmh/#/how-to-redeem-amazon-rewards"
                              target="_blank"
                            >
                              Review Amazon instructions here
                            </a>
                          </div>
                          <div className="logo-item">
                            <div className="logo-des">
                              &gt; Receive your gift card via email
                              <br />
                              &gt; Apply to your Amazon account <br />
                              &gt; Search and watch on Amazon directly <br />
                            </div>
                            <a
                              className="des-link"
                              href="/tmh/#/how-to-redeem-amazon-rewards"
                              target="_blank"
                            >
                              Review Amazon instructions here
                            </a>
                            <button
                              onClick={() => {
                                if (auth.isLogged()) {
                                  setOpenPopup(true)
                                } else {
                                  setRegisterPartnerId(2)
                                  if (isGGChrome()) {
                                    setOpenRegisterChromePopup(true)
                                  } else {
                                    setOpenRegisterPopup(true)
                                  }
                                }
                              }}
                              disabled={!amzAvailable}
                            >
                              SEND NOW
                            </button>
                          </div>
                        </div>
                        <div className="item">
                          <div className="logo-item">
                            {!vuduAvailable && (
                              <img
                                className="logo-vudu"
                                style={{ position: "absolute" }}
                                src={unavailableLogo}
                                alt="unavailable-logo"
                              ></img>
                            )}
                            <img
                              className="logo-vudu"
                              src={vuduLogo}
                              alt="vudu-logo-2"
                            ></img>
                            <a
                              className="logo-link"
                              href="/tmh/#/how-to-redeem-vudu-rewards"
                              target="_blank"
                            >
                              Review VUDU instructions here
                            </a>
                          </div>
                          <div className="logo-item">
                            <div className="logo-des">
                              &gt; Receive your VUDU code via email <br />
                              &gt; Watch on the free VUDU Roku app <br />
                              &gt; Use gift cards towards new movies <br />
                            </div>
                            <a
                              className="des-link"
                              href="/tmh/#/how-to-redeem-vudu-rewards"
                              target="_blank"
                            >
                              Review VUDU instructions here
                            </a>
                            <button
                              disabled={!vuduAvailable}
                              onClick={() => {
                                if (isVuduCodeLimitedWarning) {
                                  setOpenVuduCodeWarningPopup(true)
                                } else if (!registerMode) {
                                  handleRequestButton(4)
                                } else {
                                  setRegisterPartnerId(4)
                                  if (isGGChrome()) {
                                    setOpenRegisterChromePopup(true)
                                  } else {
                                    setOpenRegisterPopup(true)
                                  }
                                }
                              }}
                            >
                              SEND NOW
                            </button>
                          </div>
                        </div>
                      </div>
                      <div className="note">
                        {error !== "" && (
                          <div className="red-color-note">
                            {error}
                            {error === "Need Install Roku Remote Extension" && (
                              <a
                                href={rokuRemoteExtUrl}
                                target="_blank"
                                rel="noreferrer"
                              >
                                {" "}
                                here
                              </a>
                            )}
                            {error === "Need Install Roku Remote App" && (
                              <a
                                href="https://freemoviehouse.tv/#/install-app"
                                target="_blank"
                                rel="noreferrer"
                              >
                                {" "}
                                here
                              </a>
                            )}
                          </div>
                        )}
                        * Please allow up to 24hours to receive your gift card
                        via email. <br />* Note: Vudu redemptions are limited to
                        5 per Vudu account
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}

            <div className="box3">
              <div className="box-wraper">
                <div className="box-title">
                  Top free new release movies that others have recently watched!
                </div>

                <div className="box-content">
                  <div />
                  <div className="movie-item">
                    <img src={movie1} alt="movie-img" />
                  </div>
                  <div className="movie-item">
                    <img src={movie2} alt="movie-img" />
                  </div>
                  <div className="movie-item">
                    <img src={movie3} alt="movie-img" />
                  </div>
                  <div className="movie-item">
                    <img src={movie4} alt="movie-img" />
                  </div>
                  <div className="movie-item">
                    <img src={movie5} alt="movie-img" />
                  </div>
                  <div className="movie-item">
                    <img src={movie6} alt="movie-img" />
                  </div>
                  <div className="movie-item">
                    <img src={movie7} alt="movie-img" />
                  </div>
                  <div className="movie-item">
                    <img src={movie8} alt="movie-img" />
                  </div>
                  <div />
                </div>
              </div>
            </div>
          </div>
          <Popup
            modal
            open={openPopup}
            overlayStyle={{
              backgroundColor: "#000000B2",
            }}
          >
            <div className="modal-request-coupon-page">
              <div className="content">
                <div className="description">
                  <b>Please note:</b>
                </div>
                <div className="description">
                  This movie coupon is for Amazon.com’s movie library only and
                  not redeemable using the Amazon Prime Video app. Please review
                  the instructions before proceeding with your choice.
                </div>

                <button
                  className="close-button"
                  onClick={() => setOpenPopup(false)}
                >
                  Go Back
                </button>
                <button
                  className="proceed-button"
                  onClick={() => handleRequestButton(2)}
                >
                  Proceed
                </button>
              </div>
            </div>
          </Popup>

          <Popup
            modal
            open={openRegisterPopup}
            overlayStyle={{
              backgroundColor: "#000000B2",
            }}
          >
            <div className="modal-register-request-coupon-page">
              <div className="bg">
                <div className="content">
                  <div className="title">
                    <b>Complete your bonus claim!</b>
                  </div>
                  <div className="description">
                    Create a password for your Movie House Profile, this will
                    allow you to have more spins and claim future New Release
                    Movies.
                  </div>

                  <div>
                    <input
                      type="password"
                      placeholder="Password"
                      autoComplete="off"
                      value={password}
                      onChange={({ target }) => {
                        setPassword(target.value)
                        setRegisterErr(
                          target.value !== confirmPassword &&
                            confirmPassword !== ""
                            ? "Password do not match"
                            : ""
                        )
                      }}
                    />
                  </div>

                  <div>
                    <input
                      type="password"
                      placeholder="Re-enter Password"
                      autoComplete="off"
                      value={confirmPassword}
                      onChange={({ target }) => {
                        setConfirmPassword(target.value)
                        setRegisterErr(
                          target.value !== password && password !== ""
                            ? "Password do not match"
                            : ""
                        )
                      }}
                    />
                  </div>

                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      textAlign: "center",
                      justifyContent: "center",
                      gap: 8,
                    }}
                  >
                    <input
                      id="terms-checkbox"
                      className="terms-checkbox"
                      type="checkbox"
                      placeholder="Re-enter Password"
                      autoComplete="off"
                      checked={isTermCheckboxChecked}
                      onChange={event => {
                        setIsTermCheckboxChecked(event.target.checked)
                      }}
                    />

                    <label className="terms-label" htmlFor="terms-checkbox">
                      Accept{" "}
                      <a href="/tmh/#/terms-conditions" target="_blank">
                        The Movie House Terms
                      </a>{" "}
                      and{" "}
                      <a href="/tmh/#/privacy-policy" target="_blank">
                        Privacy Policy
                      </a>
                    </label>
                  </div>

                  <div style={{ color: "red" }}>{registerErr}</div>

                  <button
                    className="proceed-button"
                    disabled={isRegisterButtonDisabled}
                    onClick={() => {
                      registerByPin(password)
                    }}
                  >
                    Complete & visit profile
                  </button>
                </div>
              </div>
            </div>
          </Popup>

          <Popup
            modal
            open={requiredApp === "Extension"}
            overlayStyle={{
              backgroundColor: "#000000B2",
            }}
          >
            <div className="modal-register-request-coupon-page">
              <div className="bg">
                <div className="content-3">
                  <div className="title">
                    <b>Congratulations</b>
                  </div>

                  <div className="description">
                    You've reached 100% on your progress bar, claim your Premium
                    New Release Movie via the Roku Movie Remote extension.
                  </div>

                  <div className="images-block">
                    <img src={ExtImg} className="ext-img" alt="ext" />
                    <img src={NotesImg} className="notes-img" alt="notes" />
                  </div>

                  <div className="description-r2">
                    Once installed and confirmed your Free New Release will be
                    activated
                  </div>

                  <button
                    className="proceed-button"
                    onClick={() => {
                      window.open(rokuRemoteExtUrl, "_blank")
                    }}
                  >
                    INSTALL & CLAIM NOW
                  </button>
                </div>
              </div>
            </div>
          </Popup>

          <Popup
            modal
            open={requiredApp === "Mobile"}
            overlayStyle={{
              backgroundColor: "#000000B2",
            }}
          >
            <div className="modal-register-request-coupon-page">
              <div className="bg">
                <div className="content-3">
                  <div className="title">
                    <b>Congratulations</b>
                  </div>

                  <div className="description">
                    You've reached 100% on your progress bar, claim your Premium
                    New Release Movie via the Roku Movie Remote.
                  </div>

                  <div className="images-block">
                    <img
                      src={MobileAppImg}
                      className="mobile-img"
                      alt="mobile"
                    />
                    <img src={NotesImg} className="notes-img" alt="notes" />
                  </div>

                  <div className="description-r2">
                    Once installed and confirmed your Free New Release will be
                    activated
                  </div>

                  <a
                    className="remote-app-link"
                    href="https://mymovieremote.com/"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <b>
                      Scan or visit{" "}
                      <span style={{ color: "rgba(37, 211, 102, 1)" }}>
                        MyMovieRemote.Com
                      </span>{" "}
                      Now
                    </b>
                  </a>
                </div>
              </div>
            </div>
          </Popup>

          <Popup
            modal
            open={openRegisterChromePopup}
            overlayStyle={{
              backgroundColor: "#000000B2",
            }}
          >
            <div className="modal-register-request-coupon-page">
              <div className="bg">
                <div className="content-2">
                  <div className="title">
                    <b>Final Steps To Claim</b>
                  </div>
                  <div className="flex-container">
                    <img src={TickImg} className="tick-img" alt="tick" />
                    <div className="description">
                      <b>Create a password for the Movie House Profile, </b>
                      <br />
                      Gets you more spins for daily Movies + Movie Tickets.
                    </div>
                  </div>

                  <div>
                    <input
                      type="password"
                      placeholder="Password"
                      autoComplete="off"
                      value={password}
                      onChange={({ target }) => {
                        setPassword(target.value)
                        setRegisterErr(
                          target.value !== confirmPassword &&
                            confirmPassword !== ""
                            ? "Password do not match"
                            : ""
                        )
                      }}
                    />
                  </div>

                  <div>
                    <input
                      type="password"
                      placeholder="Re-enter Password"
                      autoComplete="off"
                      value={confirmPassword}
                      onChange={({ target }) => {
                        setConfirmPassword(target.value)
                        setRegisterErr(
                          target.value !== password && password !== ""
                            ? "Password do not match"
                            : ""
                        )
                      }}
                    />
                  </div>

                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      textAlign: "center",
                      justifyContent: "center",
                      gap: 8,
                    }}
                  >
                    <input
                      id="terms-checkbox"
                      className="terms-checkbox"
                      type="checkbox"
                      placeholder="Re-enter Password"
                      autoComplete="off"
                      checked={isTermCheckboxChecked}
                      onChange={event => {
                        setIsTermCheckboxChecked(event.target.checked)
                      }}
                    />

                    <label className="terms-label" htmlFor="terms-checkbox">
                      Confirm you accept{" "}
                      <a href="/tmh/#/terms-conditions" target="_blank">
                        The Movie House Terms
                      </a>{" "}
                      and{" "}
                      <a href="/tmh/#/privacy-policy" target="_blank">
                        Privacy Policy
                      </a>{" "}
                    </label>
                  </div>

                  <div style={{ color: "red" }}>{registerErr}</div>

                  <div className="break-block" />

                  <div className="flex-container">
                    <img src={TickImg} className="tick-img" alt="tick" />
                    <div className="description">
                      <b>Install the Roku Movie Remote extension for Chrome</b>
                      <br />
                      Control your Roku from your browser ✔<br />
                      Claim FREE movies and more daily ✔
                    </div>
                  </div>

                  <button
                    className="proceed-button"
                    disabled={isRegisterButtonDisabled}
                    onClick={() => {
                      registerByPin(password, true)
                    }}
                  >
                    Get your Movie via Roku Movie Remote
                  </button>

                  <div style={{ fontSize: 20, marginTop: 10 }}>
                    {progressLocked
                      ? "Once downloaded and confirmed spin and claim your movies direct in Roku Movie Remote"
                      : "Once confirmed return to this page and refresh to claim, or claim direct in Roku Movie Remote"}
                  </div>
                </div>
              </div>
            </div>
          </Popup>

          <Popup
            modal
            open={openVuduCodeWarningPopup}
            overlayStyle={{
              backgroundColor: "#000000B2",
            }}
          >
            <div className="modal-Vudu-warning-request-coupon-page">
              <div className="bg">
                <div className="content">
                  <div className="description">
                    You have reached the maximum (5) claimed movies allowed for
                    Vudu. For future claims please ensure you select Amazon when
                    you reach 100%.
                  </div>

                  <button
                    className="proceed-button"
                    onClick={() => {
                      handleRequestButton(4)
                    }}
                  >
                    OK, Continue
                  </button>
                </div>
              </div>
            </div>
          </Popup>
        </TMHBanner>
      )}

      {isLoading && <TMHLoader />}
    </>
  )
}
